export const CLEAR_MEMBERSHIPS = "metabase/admin/people/CLEAR_MEMBERSHIPS";
